import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
  DeleteRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetRevieweesArgsType = GetRequestArgsType & {
  reviewCode: string;
  revieweeId?: number | null;
};

export type PostRevieweePayloadType = {
  tenantUserId: number;
};

export type PostRevieweeArgsType = PostRequestArgsType<PostRevieweePayloadType> & {
  reviewCode: string;
};

export type DeleteRevieweeArgsType = DeleteRequestArgsType & {
  reviewCode: string;
  revieweeId: number;
};

export const apiFetchReviewees = async ({
  domain = useTenantStore().domain,
  reviewCode,
  revieweeId = null,
  query = {},
  errorConfig = {},
  callbacks = {},
}: GetRevieweesArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.reviewees({ domain, reviewCode, revieweeId }),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiCreateReviewee = async ({
  domain = useTenantStore().domain,
  reviewCode,
  payload,
  validateStatus = null,
  errorConfig = {},
  callbacks = {},
}: PostRevieweeArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.reviewees({ domain, reviewCode }),
      payload,
      validateStatus,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteReviewee = async ({
  domain = useTenantStore().domain,
  reviewCode,
  revieweeId,
  errorConfig = {},
  callbacks = {},
}: DeleteRevieweeArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.reviewees({ domain, reviewCode, revieweeId }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiFetchBacklogReviewees = async ({
  domain = useTenantStore().domain,
  query = {},
  errorConfig = {},
  callbacks = {},
}: GetRequestArgsType = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.backlogReviewees({ domain }),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
